module.exports = __webpack_public_path__ + "static/media/award.e2b67a23.png";